module.exports = __webpack_public_path__ + "img/background-destination-desktop.3147d06c.jpg";